import { Contact } from "../models/Contact";
import type { LeadPassenger } from "../models/Passenger";

export function transformLeadPassengerToContact(passenger: LeadPassenger): Contact {
    const contact = new Contact();
    contact.birthdayAt = passenger.birthdayAt;
    contact.countryId = passenger.countryId;
    contact.email = passenger.email;
    contact.firstName = passenger.firstName;
    contact.lastName = passenger.lastName;
    contact.phoneNumber = passenger.phoneNumber;
    return contact;
}
